import { CUSTOMIZATION_TAB_ID } from '@/modules/customization/entities/enums/customizations.enums';

export const customizationsTabs = [
  {
    id: CUSTOMIZATION_TAB_ID.LOGO,
    label: 'Logo',
  },
  {
    id: CUSTOMIZATION_TAB_ID.BANNER,
    label: 'Banner',
  },
];
